import { IXC_PORTFOLIO_V1_TRANSACTION_STATE_ENTITY_NAME } from '@interxfi/api-client/generated/entities/ixc-portfolio-v1-transaction-state';
import { Pill, type PillProps } from '@interxfi/design-system/components/pill/pill';
import { TranslatedText } from '@interxfi/translation/components/translated-text';
import type { IxcPortfolioV1TransactionStatus } from '@interxfi/types/generated/api';
import { getEntityVariant } from '../../../util/entity-status-variants';

interface PortfolioTransactionStatusPillProps extends Omit<PillProps, 'children' | 'variant'> {
  status: IxcPortfolioV1TransactionStatus | undefined;
}

export function PortfolioTransactionStatusPill({ isPending, status, ...props }: PortfolioTransactionStatusPillProps) {
  return (
    <Pill isPending={!status || isPending} {...props} variant={getEntityVariant(IXC_PORTFOLIO_V1_TRANSACTION_STATE_ENTITY_NAME, status)}>
      <TranslatedText defaultValue={status} i18nKey={{ namespace: 'ixcPortfolioV1', enumName: 'IxcPortfolioV1TransactionStatus', value: status }} />
    </Pill>
  );
}
